export default __webpack_public_path__ + "static/media/014-rain.632bfff6.svg";